export default __webpack_public_path__ + "static/media/AdobeStock_386606050.77ad1c48.jpg";